export const iconFontAwesomeArrowsCloudArrowDown = (
	<i className="fa-solid fa-cloud-arrow-down"></i>
);
